<template>
  <div class="animated fadeIn row">
    <div class="card w-full">
      <div class="card-header">
        <strong>เพิ่มบริการ <i class="far fa-plus"></i></strong>
      </div>
      <div class="card-body">
        <div v-if="submit.active==false">
        <div class="col-lg-12 col-sm-12 form-group row" v-if="service.languages.data.length != 1">
          <div v-for="language in service.languages.data" :key="language.short_name"
            class="mx-1 text-center">
            <b-button block variant="outline-info" @click="setLanguage(language.short_name)" :class="{active: language.short_name === data.lang }">
              {{ language.name }}
              <span v-bind:class="'flag-icon flag-icon-us'" v-if="covertoLowerCase(language.short_name)=='en'"></span>
              <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(language.short_name)" v-if="covertoLowerCase(language.short_name)!='en'"></span>
            </b-button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label for="name">ชื่อบริการ<span v-if="data.service.lang!=''"> {{data.service.lang}}</span>&nbsp;<i
                  class="far fa-bookmark"></i>
                : </label>
              <input class="form-control" v-model="data.service[data.lang].title" type="text" placeholder="กรุณากรอกชื่อบริการ">
            </div>
          </div>
        </div>
          <div class="col-sm-12">
            <div class="form-group">
              <label for="name">วันที่สร้าง: </label>
              <datepicker :bootstrap-styling="true" v-model="data.created_at" placeholder="กรุณาคลิกเลือกวันที่สร้าง"></datepicker>
            </div>
          </div>
        <div class="row form-group">
          <rich-editor class="col-sm-12" v-model="data.service[data.lang].description"></rich-editor>
        </div>
        <div class="col-sm-12">
          <div class="form-group row" v-if="data.image!=''">
            <div class="offset-lg-3 col-lg-6 text-center">
              <label for="ccnumber">รูปตัวอย่าง <i class="far fa-image"></i></label>
              <img v-bind:src="data.image" @error="imageLoadError" class="d-block w-full">
            </div>
          </div>
          <div class="form-group row">
            <div class="offset-lg-2 col-lg-4">
              <button type="button" class="btn btn-outline-primary btn-block w-full" @click="openModal('upload')"><i
                  class="far fa-upload"></i> อัพโหลดรูปจากเครื่อง</button>
            </div>
            <div class="col-lg-4">
              <button type="button" class="btn btn-outline-info btn-block w-full" @click="openModal('link')"><i class="far fa-link"></i>
                อัพโหลดรูปจากลิงค์</button>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="offset-sm-3 offset-lg-3 col-sm-3 col-lg-3">
            <button class="btn btn-primary w-full" type="submit" @click="submitService"><i class="far fa-clipboard-check"></i>
              ยืนยัน</button>
          </div>
          <div class="col-sm-3 col-lg-3">
            <router-link :to="{ name: 'ServicesList'}"><button class="btn btn-secondary w-full" type="button"><i class="far fa-times-square"></i>
                ยกเลิก</button></router-link>
          </div>
        </div>
        </div>
        <div v-if="submit.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="service.modal.title" ref="model" hide-footer v-model="service.modal.active" @ok="service.modal.active = false">
      <div v-if="service.modal.action=='link'">
        <div class="row">
          <div class="col-md-12">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">URL</span>
              </div>
              <input type="text" class="form-control" v-model="data.image">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
          </div>
          <div class="col-lg-6">
            <b-btn class="mt-3" variant="outline-secondary" block @click="cancleImageLink">ยกเลิกการเปลี่ยนแปลง</b-btn>
          </div>
        </div>
      </div>
      <div v-if="service.modal.action=='upload'">
        <div v-if="service.img.upload.active==false">
          <div class="custom-file" v-if="service.img.crop.active">
            <input type="file" name="image" accept="image/*" class="custom-file-input" @change="setImage" />
            <label class="custom-file-label" for="customFile">Choose file</label>
          </div>
          <div v-if="service.img.view.active">
            <div v-if="service.img.crop.active" style="width: 100%; height:68.5%; border: 1px solid gray; display: inline-block;">
              <vue-cropper ref='cropper' :src="service.img.view.src" :guides="true" :view-mode="2" drag-mode="crop"
                :initialAspectRatio="100/68.5" :aspectRatio="100/68.5" :auto-crop-area="0.5" :min-container-width="100"
                :min-container-height="68.5" :background="true" :rotatable="true" alt="zeedoc-img-service" :img-style="{ 'width': '100%', 'height': '68.5%' }">
              </vue-cropper>
            </div>
            <div>
              <div v-if="!service.img.crop.active">
                <label for="ccnumber">ภาพที่จะแสดงในบริการ <i class="far fa-image"></i></label>
                <img :src="service.img.crop.src" style="width: 100%; height: 68.5%; border: 1px solid gray" alt="ตัวอย่างรูปที่จะนำเข้า" />
                <hr>
              </div>
            </div>
          </div>
          <div class="row" v-if="service.img.crop.active && service.img.view.src">
            <div class="offset-lg-2 col-lg-8">
              <br/>
              <b-btn @click="cropImage" variant="primary" block>เลือกภาพนี้</b-btn>
            </div>
          </div>
          <div class="row" v-if="!service.img.crop.active && service.img.crop.src">
            <div class="col-lg-6">
              <b-btn variant="outline-primary" block @click="submitImage">ยืนยันการเปลี่ยนแปลง</b-btn>
            </div>
            <div class="col-lg-6">
              <b-btn @click="cancleImage" variant="secondary" block>ยกเลิกภาพ</b-btn>              
            </div>
          </div>
        </div>
        <div v-if="service.img.upload.active">
          <div class="loader-container-4tiles clearfix">
            <div class="square s9 rounded"></div>
            <div class="square s2 rounded"></div>
            <div class="square s1 rounded"></div>
            <div class="square s6 rounded"></div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueCropper from 'vue-cropperjs'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import Multiselect from 'vue-multiselect'
  import Helper from '@/shared/helper'
  import RichEditor from '@/components/richEditor'
  import uploadImage from '@/components/uploadImage'
  import Datepicker from 'vuejs-datepicker'

  export default {
    components: {
      Datepicker,
      Multiselect,
      VueCropper,
      RichEditor,
      uploadImage
    },
    mixins: [Helper],
    data() {
      return {
        load: 0,
        submit:{
          active: false,
          error: false
        },
        no_image:{
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        service: {
          id: parseInt(this.$route.params.id),
          languages: {
            count: 1,
            data: []
          },
          img: {
            upload: {
              active: false
            },
            view: {
              src: '',
              active: false
            },
            crop: {
              src: '',
              active: false
            }
          },
          modal: {
            title: '',
            action: '',
            active: false
          },
        },
        authorization: 'Bearer ' + localStorage.getItem('z_token'),
        data: {
          page: 0,
          per_page: 0,
          lang: 'th',
          session: [],
          image: '',
          created_at: null,
          service: {
            th: {
              id: '',
              title: '',
              description: '',
              created_at:'',
              lang: ''
            }
          }
        }
      }
    },
    methods: {
      covertoLowerCase(title){
        if(title&&title!=''){
          return title.toLowerCase()
        }else{
          return title
        }
      },
      openModal(action) {
        this.service.img.view.active = false
        this.service.modal.action = action
        this.service.img.crop.active = true
        if (action == 'upload') {
          this.service.img.view.src = null
          this.service.modal.title = 'อัพโหลดรูปจากเครื่อง'
          this.service.modal.active = true
        } else if (action == 'link') {
          this.service.modal.title = 'อัพโหลดรูปจากลิงค์'
          this.service.modal.active = true
        }
      },
      setLanguage(language) {
        this.data.lang = language
      },
      setImage(e) {
        const file = e.target.files[0]
        this.service.img.view.active = true
        if (!file.type.includes('image/')) {
          alert('Please select an image file')
          return
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.service.img.view.src = event.target.result
            this.$refs.cropper.replace(event.target.result)
          }
          reader.readAsDataURL(file)
        } else {
          alert('Sorry, FileReader API not supported')
        }
      },
      submitService() {
        if (this.service.id != '' && this.service.id) {
          this.checkUpdateService()
        } else {
          this.checkService()
        }
      },
      imageLoadError(event){
        this.data.image = ''
        event.target.src = this.no_image.src
      },
      createService(data, isfunc) {
        this.$http.post(process.env.VUE_APP_API_URL + 'api/v1/service', data, {
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          let item = null
          this.checkLoad()
          if (isfunc == true) {
            for (item in this.data.session) {
              this.createService({
                'title': this.data.session[item].title,
                'description': this.data.session[item].description,
                'created_at':this.data.session[item].created_at,
                'image': this.data.session[item].image,
                'id': response.body.json.service.id,
                'locale': item
              }, false);
            }
          }
          if (this.load == 0) {
            alert('บริการสร้างเรียบร้อย');
            this.$router.push({
              name: 'ServicesList'
            })
          }
        }).catch(function (error) {
          if(this.submit.error==false){
            this.submit.error = true
            alert('ไม่สามารถสร้างบริการได้ กรุณากรอกชื่อของบริการ!');
            this.$router.push({
              name: 'ServicesList'
            })
          }
        })
      },
      checkService() {
        this.data.session = []
        let item = null
        let isVal = false
        let emtpyCount = 0
        let data = []
        this.startLoad(this.service.languages.count)
        for (item in this.data.service) {
          if (this.data.service[item].title != '' && this.data.service[item].title) {
            if (isVal) {
              this.data.session[item] = this.data.service[item]
            } else {
              if(this.data.service[item].title.length>5){
                this.submit.active = true
                this.createService({
                  'title': this.data.service[item].title,
                  'description': this.data.service[item].description,
                  'created_at':this.data.service[item].created_at,
                  'image': this.data.image,
                  'locale': item
                }, true)
              }else{
                this.checkLoad()
                alert("กรุณากรอกชื่อของบริการที่มีความยามมากกว่า5ตัวอักษร ("+item+")")
              }
            }
            isVal = true
          } else {
            this.checkLoad()
            emtpyCount = emtpyCount + 1
            if(emtpyCount==this.service.languages.count){
              this.submit.active = false
              alert('กรุณาใส่ข้อมูลของบริการ')
            }
          }
        }
      },
      async updateService(data){
        try {
          await this.$http.put(process.env.VUE_APP_API_URL + 'api/v1/service/' + this.service.id, data, {
            headers: {
              Authorization: this.authorization
            }
          })
        } catch (e) {
          if(this.submit.error==false){
            this.submit.error = true
            alert('ไม่สามารถสร้างบริการได้ กรุณากรอกชื่อของบริการ!')
            this.$router.push({
              name: 'ServicesList'
            })
          }
        }
        this.checkLoad()
      },
      async checkUpdateService() {
        let item = null
        let emtpyCount = 0
        this.startLoad(this.service.languages.count)
        console.log('service list')
        console.log(this.data.service)
        for (item in this.data.service) {
          if (this.data.service[item].title != '' && this.data.service[item].title) {
            if(this.data.service[item].title.length>5){
              this.submit.active = true
              console.log('update')
              await this.updateService({
                'id': this.data.service[item].id,
                'title': this.data.service[item].title,
                'description': this.data.service[item].description,
                'created_at': this.data.created_at,
                'image': this.data.image,
                'locale': item
              })
            }else{
              this.checkLoad()
              alert("กรุณากรอกชื่อของบริการที่มีความยามมากกว่า5ตัวอักษร ("+item+")")
            }
          }else{
            this.checkLoad()
            emtpyCount = emtpyCount + 1
            if(emtpyCount==this.service.languages.count){
              this.submit.active = false
              alert('กรุณาใส่ข้อมูลของบริการ')
            }
          }
        }
        if (this.load == 0) {
          alert('บริการอัพเดทเรียบร้อย')
          this.$router.push({
            name: 'ServicesList'
          })
        }
      },
      cropImage() {
        this.service.img.crop.active = false
        this.service.img.crop.src = this.$refs.cropper.getCroppedCanvas().toDataURL('image/jpeg')
      },
      cancleImage() {
        this.service.img.view.src = null
        this.service.img.view.active = false
        this.service.img.crop.active = true
        this.service.img.crop.src = null
      },
      cancleImageLink() {
        this.service.img.view.active = false
        this.service.img.crop.active = true
        this.service.img.crop.src = null
        this.data.image = ''
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      getServiceByID(id, lang) {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/service/' + id, {
          params: {
            lang: lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          if (response.body.json) {
            this.data.service[response.body.json.locale].id = response.body.json.id
            this.data.service[response.body.json.locale].title = response.body.json.title
            this.data.service[response.body.json.locale].description = response.body.json.description
            this.data.service[response.body.json.locale].created_at = response.body.json.created_at
            this.data.created_at = response.body.json.created_at
            if(response.body.json.image&&response.body.json.image!=''){
              this.data.image = response.body.json.image
            }else{
              this.data.image = this.no_image.src
            }
          }
        }, response => {
          this.checkLoad()
        })
      },
      async submitImage() {
        if (this.service.img.crop.src != '' && this.service.img.crop.src) {
          this.service.img.upload.active = true
          try {
            this.data.image = await this.uploadImageDataUrl(this.service.img.crop.src, 'service.jpg')
            this.service.img.upload.active = false
            this.cancleImageLink
            this.$refs.model.hide()
          } catch (error) {
              this.service.img.upload.active = false
              alert('คุณใส่ชนิดหรือรูปแบบของรูปภาพไม่ถูกต้อง!')
              this.cancleImageLink
              this.$refs.model.hide()
          }
        } else {
          this.service.img.upload.active = false
          this.$refs.model.hide()
        }
      },
      getLanguages() {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/languages', {
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          const numLanguage = response.body.json.length
          let item = null
          if (numLanguage >= 1) {
            this.service.languages.count = response.body.json.length
            this.service.languages.data = response.body.json
            this.startLoad(this.service.languages.count + 1)
            for (item in this.service.languages.data) {
              this.data.service[this.service.languages.data[item].short_name] = {
                title: '',
                image: '',
                description: '',
                lang: '',
                created_at:''
              }
              if (Number.isInteger(this.service.id)) {
                this.getServiceByID(this.service.id, this.service.languages.data[item].short_name)
              }
            }
            this.setLanguage(this.service.languages.data[0].short_name)
          }
        }, response => {
          this.failLoad()
        })
      }
    },
    mounted() {
      this.getLanguages()
    }
  }
</script>
<style lang="scss">
.ql-editor {
  height: 20rem !important;
}
</style>
